import $ from 'jquery';

const getPageYOffset = () => Math.round(window.pageYOffset);
let lastScrollTop = getPageYOffset();

export default () => {
  const currentScrollTop = getPageYOffset();
  const direction = currentScrollTop > lastScrollTop ? 'down' : 'up';

  lastScrollTop = getPageYOffset();

  return direction;
}
